
import React, { useEffect, useMemo, useState } from 'react';
import { DEFAULT_PROFILE_IMAGE } from '@/constants/common';
import { transformImageUrl } from '@/utils/image.util';

type Props = {
  url: string | null | undefined;
  className?: string;
  alt?: string;
  onClick?: () => void;
};

function normalizeUrl(raw: string | null | undefined): string {
  const t = raw?.trim();
  if (!t) return DEFAULT_PROFILE_IMAGE;
  const x = transformImageUrl(t);
  return typeof x === 'string' && x.length > 0 ? x : t;
}

/**
 * Circular recommender thumbnail: same URL rules as cards/modal (`transformImageUrl`).
 * Missing or broken URLs use `DEFAULT_PROFILE_IMAGE` — same legacy default as `useAvatarImage`.
 */
export const RecommenderAvatarImage: React.FC<Props> = ({ url, className, alt = 'Recommender avatar', onClick }) => {
  const normalized = useMemo(() => normalizeUrl(url), [url]);
  const [src, setSrc] = useState(normalized);

  useEffect(() => {
    setSrc(normalizeUrl(url));
  }, [url]);

  const handleError = () => {
    setSrc(DEFAULT_PROFILE_IMAGE);
  };

  return (    <img src={src} alt={alt} className={className} onError={handleError} onClick={onClick} />
  );
};
